import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTimezonePipe } from './custom-timezone.pipe';



@NgModule({
  declarations: [CustomTimezonePipe],
  imports: [
    CommonModule
  ],
  exports: [
    CustomTimezonePipe
  ]
})
export class PipesModule { }
